<template>
  <MultipleChoicesDropdown
    title="investor type"
    :value="value"
    :show-clear-all="false"
    :single-choice="true"
    :search-enabled="false"
    :choices="choices"
    @change="onChange($event)"
  />
</template>

<script>
import { mapState } from 'vuex'
import { investorTypeChoices } from '@/services/investor-types'

export default {
  props: {
    value: String,
  },
  data: () => ({
    choices: investorTypeChoices,
  }),
  methods: {
    onChange(choice) {
      this.$emit('change', choice)
    },
  },
}
</script>
